export class Item {
  constructor(id = '', name = '', value = '') {
    this.id = id;
    this.name = name;
    this.text = name;
    this.value = value;
    this.icon = '';
    this.opened = false;
    this.disabled = false;
    this.selected = false;
    this.seg = "";
    this.req = "";
    this.loop = "";
    this.dataname = "";    
  }

  listItems() {
    return [this];
  }

  toJson() {    
    //return { id: `${this.id}`, name: `${this.name}`, text: `${this.name}`, icon: `${this.icon}`, opened: `${this.opened}`, disabled: `${this.disabled}` };
    //return { id: `${this.id}`, name: `${this.name}`, text: `${this.name}`, icon: `${this.icon}`, opened: this.opened, disabled: this.disabled };
    return { id: `${this.id}`, name: `${this.name}`, text: `${this.name}`, icon: `${this.icon}`, opened: this.opened, disabled: this.disabled , seg: this.seg, req: this.req, loop: this.loop, dataname: this.dataname};
    
  }

  toJson_backup() {
    const vertex = `${this.name}|V|C|1|${this.name}`;
    return { ITEM: vertex };
  }
}

// export default Item;

